
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const teamsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getTeams: build.query<any, void>({
      query: () => ({
        url: appEndpoint.teamProfiles,
        method: 'get',
      }),
      providesTags: ['Teams'],
    }),
    addTeam: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.teamProfiles,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Teams"] : []),
    }),

    updateTeam: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.teamProfiles}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Teams"] : []),
    }),
    

    deleteTeam: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.teamProfiles}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Teams'],
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetTeamsQuery,
  useDeleteTeamMutation,
  useUpdateTeamMutation,
  useAddTeamMutation
} = teamsApi;